import { TEAM_MANAGEMENT } from "../../routes";
import type { AddableRole } from "./teamRoles";

/** What ADD MEMBER starts with: one person's name, role and Circles. */
export type TeamMemberPrefill = {
  displayName?: string;
  accessLevel?: AddableRole;
  circleIds?: string[];
};

/** What another page hands Team in router state: a search to run, or a team member to start adding. */
export type TeamHandover = { search?: string; addMember?: TeamMemberPrefill };

/** Team's router state, read on arrival; anything else is no handover. */
export const readTeamHandover = (state: unknown): TeamHandover => {
  const { search, addMember } = (state ?? {}) as TeamHandover;
  return {
    ...(typeof search === "string" && search ? { search } : {}),
    ...(addMember && typeof addMember === "object" ? { addMember } : {}),
  };
};

export const toTeam = (handover: TeamHandover = {}) => ({
  pathname: TEAM_MANAGEMENT,
  state: handover,
});
